<template>
    <div class="company-managers-widget">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div :class="settings.organization ? 'viewport-list' : 'viewport-sidebar'">
            <div class="invite-form">
                <md-field>
                    <div class="icon-wrap" v-if="settings.cancel">
                        <img src="@/assets/icons/ic_mail.svg" alt="ico">
                    </div>
                    <label>{{ $ml.get('EnterEmailToAssignCompanyManager') }}</label>
                    <md-input v-model="inviteManagerInput" type="text"></md-input>
                    <span class="md-helper-text">{{$ml.get('enterSeveralEmailByComma')}}</span>
                </md-field>
                <b-button :class="{disabled: !inviteLoad}"
                          class="primaryButton"
                          :disabled="!inviteLoad"
                          @click="inviteManager"
                >
                    <b-spinner v-if="!inviteLoad" small></b-spinner>
                    <span v-else>{{$ml.get('Invite')}}</span>
                </b-button>
                <b-button class="primaryButton reverse"
                          @click="$emit('cancel')"
                          v-if="settings.cancel"
                >
                    <span>{{$ml.get('Cancel')}}</span>
                </b-button>
            </div>
            <div class="active-managers inline-list">
                <div v-if="inviteLoadRender && managers.length == 0 && invites.length == 0" class="no-managers">
                    <img src="@/assets/icons/ic_account.svg" alt="ico">
                    {{$ml.get('NoOthersCompanyManagersAssigned')}}
                </div>
                <div v-else-if="inviteLoadRender">
                    <div class="active-managers-list">
                        <ul>
                            <li v-for="item in managers" :key="item.guid">
                                <div class="group">
                                    <a :href="'mailto:' + item.email">{{item.email}}</a>
                                    <div class="status">
                                        <span class="accepted">{{$ml.get('Accepted')}}</span>
                                    </div>
                                </div>
                                <button @click="removeManagerConfirm(item)">
                                    <div>
                                        <img src="@/assets/icons/ic_trash_black.svg">
                                        <span>{{$ml.get('Remove')}}</span>
                                    </div>
                                </button>
                            </li>
                            <li v-for="item in invites" :key="item.guid">
                                <div class="group">
                                    <a :href="'mailto:' + item.email">{{item.email}}</a>
                                    <div class="status">
                                        <span class="pending">{{$ml.get('Pending')}}</span>
                                    </div>
                                </div>
                                <button @click="cancelInviteConfirm(item)">
                                    <div>
                                        <img src="@/assets/icons/ic_trash_black.svg">
                                        <span>{{$ml.get('Remove')}}</span>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="block-spinner">
                    <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Vue from 'vue'
    import _ from "lodash";
    import {MdField} from 'vue-material/dist/components'
    import '@/assets/css/MdField.css'
    import {mapActions} from 'vuex'
    //
    import errorMixin from '@/mixins/errorMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import logAnalyticsEvent, {logError} from '@/helpers/analytics'

    Vue.use(MdField)

    export default {
        mixins: [errorMixin],

        components: {
            customModalDialog
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        validate: true
                    }
                }
            },
        },

        data() {
            return {
                moduleSettings: !_.isEmpty(this.settings),
                customModalSettings: {},
                //
                assignManagerSectionClass: 'default',
                inviteLoad: true,
                inviteLoadRender: false,
                inviteManagerInput: '',
                managers: [],
                invites: [],
            }
        },

        watch: {
            settings(newValue) {
                this.moduleSettings = !_.isEmpty(newValue)
                if (newValue.guid) {
                    this.getManagers(newValue.guid)
                }
            },

        },

        async mounted() {
            if (this.settings.guid) {
                await this.getManagers(this.settings.guid)
            }
        },

        methods: {
            ...mapActions({
                getManagersAction: 'organization/getManagers',
                sendInviteAction: 'organization/sendInvite',
                removeManagerAction: 'organization/removeManager',
                cancelInviteAction: 'organization/cancelInvite',
            }),

            // Company Managers
            async getManagers(guid) {
                this.inviteLoadRender = false;
                try {
                    const response = await this.getManagersAction({
                        placeID: this.settings.placeID
                    })
                    if (response) {
                        this.managers = response.managers
                        this.invites = response.invites
                        this.inviteLoadRender = true;
                    }
                } catch (e) {
                    if ((e.data.error.code == 1133) || (e.data.error.code == 1013)) {
                        this.showErrorModal(e.data.error.message, {
                            title: 'Error',
                            code: e.data.error.code
                        })
                        if (e.data.error.code == 1013) {
                            this.$router.push({name: 'Login'});
                        }
                    }
                    this.inviteLoadRender = true;
                }
            },

            checkDuplicatedEmails() {
                let input = this.inviteManagerInput
                input = input.replace(/ /g, '');
                const items = input.split(',')
                let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) == index)
                return findDuplicates(items)
            },

            async inviteManager() {
                if (this.inviteManagerInput.length != 0) {
                    this.inviteLoad = false;
                    this.inviteLoadRender = false;
                    const items = this.checkDuplicatedEmails()
                    try {
                        const response = await this.sendInviteAction({
                            placeID: this.settings.placeID,
                            body: {
                                emails: items
                            },
                        })
                        if (response.success) {
                            if (this.isSiteManagers()) {
                                logAnalyticsEvent(`sites_managers_invite_success`)
                            } else {
                                logAnalyticsEvent(`org_managers_invite_success`)
                            }
                            await this.getManagers(this.settings.guid)
                            this.inviteManagerInput = '';
                        }
                    } catch (e) {
                        if (this.isSiteManagers()) {
                            logError('sites_managers_invite_error', e.data.error.message || '')
                        } else {
                            logError('org_managers_invite_error', e.data.error.message || '')
                        }
                        this.showErrorModal(e.data.error.message)
                    } finally {
                        this.inviteLoad = true;
                        this.inviteLoadRender = true;
                    }
                }
            },

            //
            removeManagerConfirm(item) {
                this.customModalSettings = {
                    message: this.translate('removeManager', [item.email]),
                    onOkHandler: this.removeManager.bind(null, item.guid),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            cancelInviteConfirm(item) {
                this.customModalSettings = {
                    message: this.translate('cancelInvite', [item.email]),
                    onOkHandler: this.cancelInvite.bind(null, item.guid),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            //
            async removeManager(uid) {
                try {
                    const response = await this.removeManagerAction({
                        placeID: this.settings.placeID,
                        uid: uid
                    })
                    if (response.success) {
                        if (this.isSiteManagers()) {
                            logAnalyticsEvent(`site_manager_remove_manager_success`)
                        } else {
                            logAnalyticsEvent(`org_manager_remove_manager_success`)
                        }
                        await this.getManagers(this.settings.guid)
                    }
                } catch (e) {
                    if (this.isSiteManagers()) {
                        logError('site_manager_remove_manager_error', e.data.error.message || '')
                    } else {
                        logError('org_manager_remove_manager_error', e.data.error.message || '')
                    }
                    this.showErrorModal(e.data.error.message)
                }
            },

            isSiteManagers() {
                return this.settings.placeID != null
            },

            async cancelInvite(uid) {
                try {
                    const response = await this.cancelInviteAction({
                        placeID: this.settings.placeID,
                        uid: uid
                    })
                    if (response.success) {
                        if (this.isSiteManagers()) {
                            logAnalyticsEvent(`site_manager_cancel_invite_success`)
                        } else {
                            logAnalyticsEvent(`org_manager_cancel_invite_success`)
                        }
                        await this.getManagers(this.settings.guid)
                    }
                } catch (e) {
                    if (this.isSiteManagers()) {
                        logError('site_manager_cancel_invite_error', e.data.error.message || '')
                    } else {
                        logError('org_manager_cancel_invite_error', e.data.error.message || '')
                    }
                    this.showErrorModal(e.data.error.message)
                }
            },

        }
    }

</script>

<style scoped>
    /*company-managers*/
    .company-managers-widget {
        max-width: 632px;
    }

    .company-managers-widget p.description {
        color: #2F2F2F;
        font-size: 16px;
        line-height: 22px;
    }

    .company-managers-widget .invite-form {
        display: flex;
        align-items: center;
    }


    .company-managers-widget .invite-form .md-field {
        margin-right: 24px;
        width: calc(100% - 192px);
    }

    /*.company-managers-widget .invite-form button {*/
    /*    width: 168px;*/
    /*    background-color: #2F2F2F;*/
    /*    min-height: 48px;*/
    /*    border-radius: 4px;*/
    /*    !*width: 100%;*!*/
    /*}*/
    .company-managers-widget .invite-form button.reverse {
        /*color: #2F2F2F;*/
        /*border: 2px solid #2F2F2F;*/
        /*background: none;*/
        margin-top: 8px;
    }

    .company-managers-widget .viewport-sidebar .invite-form > .md-field {
        position: relative;
        width: calc(100% - 30px)!important;
        margin-left: 30px;
    }

    .company-managers-widget .viewport-sidebar .invite-form > .md-field .icon-wrap {
        position: absolute;
        left: -30px;
        opacity: .5;
    }

    .company-managers-widget .viewport-sidebar .invite-form button {
        width: 100%;
    }

    .company-managers-widget .invite-form button span {
        font-size: 14px;
        font-weight: 500;
    }

    .company-managers-widget h5 {
        color: #2F2F2F;
        font-size: 16px;
        font-weight: bold;
        line-height: 26px;
        margin-top: 20px;
        margin-bottom: 0;
    }

    .company-managers-widget .viewport-sidebar h5 {
        margin-top: 35px;
        margin-bottom: 10px;
    }

    .company-managers-widget .active-managers-list {
        max-height: 245px;
        min-height: 200px;
        overflow-y: auto;
        position: relative;
    }

    .company-managers-widget .viewport-list .active-managers-list {
        max-height: 265px;
        min-height: 200px;
    }

    .company-managers-widget .viewport-sidebar .active-managers-list {
        max-height: calc(100vh - 480px);
    }

    /*active managers bottom list*/
    .company-managers-widget .active-managers {
        margin-top: 24px;
    }
    .company-managers-widget .active-managers ul {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .company-managers-widget .active-managers ul li {
        display: flex;
        align-items: center;
        background: #F7F7F7;
        margin-bottom: 8px;
        padding: 8px 16px;
        justify-content: space-between;
        margin-left: 0;
        margin-right: 0;
    }

    .company-managers-widget .active-managers ul li .group {
        justify-content: flex-start;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        padding-right: 10px;
    }
    /*.company-managers-widget .viewport-list .active-managers ul {*/
    /*    display: table;*/
    /*}*/

    /*.company-managers-widget .viewport-sidebar .active-managers ul {*/
    /*    display: grid;*/
    /*}*/

    /*.company-managers-widget .viewport-list .active-managers ul li {*/
    /*    display: table-row;*/
    /*}*/


    .company-managers-widget .viewport-sidebar .invite-form {
        flex-direction: column;
        align-items: flex-start;
    }

    .company-managers-widget .viewport-sidebar .invite-form .md-field {
        width: 100%;
        margin-right: 0;
        margin-bottom: 45px;
    }


    .company-managers-widget .viewport-sidebar .active-managers ul li:not(:first-child) {
        margin-top: 8px;
    }

    .company-managers-widget .viewport-sidebar .active-managers ul li {
        /*display: grid;*/
        grid-gap: 0;
        grid-template-columns: auto 40px;
        margin: 0;
        border-radius: 4px;
        background-color: #F7F7F7;
        padding: 5px 15px 10px;
    }

    .company-managers-widget .viewport-list .active-managers ul li > * {
        /*display: table-cell;*/
        /*padding-bottom: 10px;*/
        /*padding-top: 10px;*/
        /*vertical-align: middle;*/
    }

    .company-managers-widget .active-managers ul li a {
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
        /*font-weight: 500;*/
    }

    .company-managers-widget .viewport-list .active-managers ul li a {
        width: 60%;
        margin-bottom: 6px;
    }

    .company-managers-widget .viewport-sidebar .active-managers ul li a {
        word-break: break-all;
        grid-column: 1 / span 1;
        grid-row: 1 / span 1;
        margin-bottom: 5px;
    }

    .company-managers-widget .active-managers ul li .status {
        min-width: 88px;
        text-align: center;
    }

    .company-managers-widget .viewport-sidebar .active-managers ul li .status {
        display: flex;
        align-items: flex-start;
        grid-column: 1 / span 1;
        grid-row: 2 / span 1;
    }


    .company-managers-widget .active-managers ul li .status > span {
        border-radius: 12px;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        color: #fff;
        padding: 4px;
        /*width: 80%;*/
        min-width: 88px;
        display: inline-block;
        margin: auto;
    }


    .company-managers-widget .viewport-sidebar .active-managers ul li .status > span {
        width: auto;
        margin: 0;
    }

    .company-managers-widget .active-managers ul li .status > span.accepted {
        background-color: #36BC00;
    }

    .company-managers-widget .active-managers ul li .status > span.pending {
        background-color: #FFBF00;
    }

    .company-managers-widget .active-managers ul li button {
        background-color: transparent;
        /*border: 0;*/
        box-shadow: none;
        /*padding-right: 0;*/
        outline: none;
        /*width: 100%;*/
        border: 2px solid #2F2F2F;
        border-radius: 4px;
        padding: 10px 14px;
    }


    .company-managers-widget .viewport-sidebar .active-managers ul li button {
        padding: 0;
        border: 0;
    }
    .company-managers-widget .viewport-sidebar .active-managers ul li button span {
        display: none;
    }

    .company-managers-widget .viewport-sidebar .active-managers ul li button {
        grid-column: 2 / span 1;
        grid-row: 1 / span 2;
    }

    .company-managers-widget .active-managers ul li button > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .company-managers-widget .active-managers ul li button > div span {
        color: #2F2F2F;
        font-size: 14px;
        font-weight: bold;
        line-height: 18px;
        margin-left: 8px;
    }


    /*other*/
    .company-managers-widget .md-field.md-invalid label {
        color: red;
    }

    /*.md-field label,*/
    .company-managers-widget .md-field:not(.md-has-value) label {
        font-size: 14px;
        top: unset;
        bottom: 0px;
    }

    .company-managers-widget .md-field .md-input {
        font-size: 14px;
        font-weight: 500;
        color: #2F2F2F;
    }

    .company-managers-widget .md-field.md-has-value label,
    .company-managers-widget .md-field.md-focused label {
        /*font-size: 13px;*/
    }

    .company-managers-widget .md-field.md-invalid:before,
    .company-managers-widget .md-field.md-invalid:after {
        background-color: rgba(255, 0, 0, 0.7);
    }

    .company-managers-widget .phone-custom.md-field label {
        left: 110px;
        z-index: 10;
    }

    .company-managers-widget .phone-custom.md-field.md-has-value label,
    .company-managers-widget .phone-custom.md-field.md-focused label {
        left: 0;
    }

    .company-managers-widget .no-managers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        max-width: 235px;
        text-align: center;
        color: #9E9E9E;
        font-size: 18px;
        line-height: 22px;
        margin: 80px auto 0;
    }

    .company-managers-widget .no-managers img {
        width: 64px;
    }

    @media screen and (max-width: 1000px) {

        .company-managers-widget .active-managers ul li button {
            padding: 5px;
        }

        .company-managers-widget .viewport-list .active-managers ul li a {
            width: 100%;
        }

        .company-managers-widget .invite-form {
            flex-direction: column;
        }

        .company-managers-widget .invite-form .md-field {
            width: 100%;
            margin-right: 0;
        }

        .company-managers-widget .invite-form button {
            width: 100%;
            margin-top: 15px;
        }

        .company-managers-widget .viewport-list .active-managers ul {
            display: grid;
            width: 100%;
        }

        .company-managers-widget .viewport-list .active-managers ul li {
            display: grid;
            grid-gap: 0;
            grid-template-columns: auto 40px;
            margin: 0 0 8px;
            border-radius: 4px;
            background-color: #F7F7F7;
            padding: 5px 15px 10px;
        }

        .company-managers-widget .active-managers ul li > * {
            margin: 0 !important;
        }

        .company-managers-widget .active-managers ul li a {
            word-break: break-all;
            grid-column: 1 / span 1;
            grid-row: 1 / span 1;
            /*margin-bottom: 10px !important;*/
            display: block;
            width: 100%;
        }

        .company-managers-widget .active-managers ul li .status {
            display: flex;
            align-items: flex-start;
            grid-column: 1 / span 1;
            grid-row: 2 / span 1;
        }

        .company-managers-widget .viewport-sidebar .active-managers ul li .status {
            grid-column: 1 / span 1;
            grid-row: 2 / span 1;
        }

        .company-managers-widget .active-managers ul li .status > span {
            width: auto;
            margin: 0;
        }

        .company-managers-widget .active-managers ul li button {
            grid-column: 2 / span 1;
            grid-row: 1 / span 2;
        }

        .company-managers-widget .active-managers ul li button img {
            width: 40px;
        }
        .company-managers-widget .active-managers ul li button span {
            display: none;
        }

    }


    @media screen and (min-width: 1001px) and (max-width: 1230px) {
        .company-managers-widget .invite-form .md-field {
            width: 100%;
            margin-right: 0;
            margin-bottom: 45px;
        }

        .company-managers-widget .invite-form {
            flex-direction: column;
            align-items: flex-start;
        }
    }

</style>
<style>
    .company-info .vue-tel-input {
        position: absolute;
        z-index: 2;
        border: none;
        width: 100%;
    }

    .company-info .vue-tel-input:focus {
        outline: none;
    }

    .company-info .vue-tel-input:focus-within {
        border: none;
        box-shadow: none;
    }

    .company-info .vti__input {
        background: none;
    }

    .company-info .vti__dropdown {
        top: -2px;
    }

    .vti__dropdown-item {
        width: 100%;
        margin: 0;
    }
</style>